import StuffToDoList from './entities/stuff-to-do-list';
// import StuffToDoImages from './entities/stuff-to-do-images';
// import StuffToDoDetails from './entities/stuff-to-do-details';
// import StuffToDoContent from './entities/stuff-to-do-content';
// import StuffToDoContents from './entities/stuff-to-do-contents';
// import StuffToDoExchange from './entities/stuff-to-do-exchange';
// import StuffToDoExchanges from './entities/stuff-to-do-exchanges';
// import StuffToDoCategories from './entities/stuff-to-do-categories';
// import StuffToDoInstruction from './entities/stuff-to-do-instruction';
// import StuffToDoInstructions from './entities/stuff-to-do-instructions';
// import StuffToDoServingSize from './entities/stuff-to-do-serving-size';
// import StuffToDoServingSizes from './entities/stuff-to-do-serving-sizes';
// import StuffToDoTypeCategories from './entities/stuff-to-do-type-categories';
// import StuffToDoNutritionFacts from './entities/stuff-to-do-nutrition-facts';
// import StuffToDoNutritionPrediction from './entities/stuff-to-do-nutrition-prediction';
// import StuffToDoNutritionFactsLabel from './entities/stuff-to-do-nutrition-facts-label';
// import StuffToDoNutritionInformation from './entities/stuff-to-do-nutrition-information';

export default {
  modules: {
    StuffToDoList,
    // StuffToDoImages,
    // StuffToDoDetails,
    // StuffToDoContent,
    // StuffToDoContents,
    // StuffToDoExchange,
    // StuffToDoExchanges,
    // StuffToDoServingSize,
    // StuffToDoServingSizes,
    // StuffToDoInstruction,
    // StuffToDoInstructions,
    // StuffToDoCategories,
    // StuffToDoTypeCategories,
    // StuffToDoNutritionFacts,
    // StuffToDoNutritionFactsLabel,
    // StuffToDoNutritionPrediction,
    // StuffToDoNutritionInformation,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/stuff-to-do/index.js